import React from 'react';
import { Star, TrendingUp, Users, Award } from 'lucide-react';
import { stats, liveDeliveries, platforms } from '../mock/mock';
import { PlatformLogo } from './PlatformLogo';

const Stats = () => {
  const items = [
    { icon: TrendingUp, label: 'Abonnés livrés ce mois', value: stats.followersDelivered },
    { icon: Users, label: 'Commandes aujourd’hui', value: stats.ordersToday },
    { icon: Award, label: 'Taux de satisfaction', value: stats.satisfaction },
    { icon: Star, label: 'Pays servis', value: `${stats.countries}+` }
  ];

  return (
    <section className="relative py-24 lg:py-32 noise-bg">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            <div className="text-[#ff8247] text-xs font-bold uppercase tracking-widest mb-3">Chiffres clés</div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Des <span className="gradient-text">chiffres</span> qui parlent d’eux-mêmes.
            </h2>
            <p className="text-white/60 leading-relaxed max-w-md">
              Depuis 2021, nous avons livré des millions d’abonnés et de likes à des créateurs, agences et marques dans plus de 47 pays.
            </p>

            <div className="grid grid-cols-2 gap-4 mt-10">
              {items.map((it, i) => (
                <div key={i} className="glass-card rounded-2xl p-5">
                  <it.icon className="w-5 h-5 text-[#ff8247] mb-3" />
                  <div className="text-3xl font-bold text-white mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{it.value}</div>
                  <div className="text-white/50 text-xs">{it.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="glass-card rounded-3xl p-6 lg:p-8">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <span className="pulse-dot" />
                  <span className="text-white font-semibold text-sm tracking-wide">EN DIRECT</span>
                </div>
                <div className="flex gap-1.5">
                  {['1J','1S','1M','6M','1A'].map((k, i) => (
                    <button key={k} className={`px-3 py-1 rounded-full text-[11px] font-semibold transition ${i === 2 ? 'bg-white text-[#0a0a0f]' : 'bg-white/5 text-white/60 hover:bg-white/10'}`}>{k}</button>
                  ))}
                </div>
              </div>

              <div className="mb-6">
                <div className="text-white/60 text-xs mb-1">Abonnés livrés ce mois</div>
                <div className="flex items-end gap-3">
                  <span className="text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{stats.followersDelivered}</span>
                  <span className="text-[#ff8247] text-sm font-semibold mb-2">+12.4% vs mois dernier</span>
                </div>
              </div>

              <div className="h-32 flex items-end gap-1.5 mb-8">
                {[38, 52, 45, 63, 55, 72, 68, 80, 75, 90, 85, 100, 92, 88, 95, 78, 84, 91, 87, 96].map((h, i) => (
                  <div key={i} className="flex-1 rounded-t-md bg-gradient-to-t from-[#ff8247]/30 via-[#ff8247]/70 to-[#ff2d6f] hover:from-[#ff8247]/60 transition" style={{ height: `${h}%` }} />
                ))}
              </div>

              <div className="border-t border-white/5 pt-6">
                <div className="text-white font-semibold mb-4 text-sm">Livraisons en cours</div>
                <div className="space-y-3">
                  {liveDeliveries.slice(0, 4).map((d, i) => {
                    const plat = platforms.find(p => p.name === d.platform);
                    return (
                    <div key={i} className="flex items-center justify-between p-3 rounded-xl bg-white/[0.02] border border-white/5">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: `${plat?.color || '#ff8247'}18` }}>
                          <PlatformLogo platform={plat?.id} className="w-5 h-5" color={plat?.id === 'instagram' ? undefined : (plat?.color || '#ff8247')} />
                        </div>
                        <div>
                          <div className="text-white text-sm font-semibold">{d.amount}</div>
                          <div className="text-white/40 text-xs">{d.platform}</div>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="pulse-dot" />
                        <span className="text-[#ff8247] text-xs font-semibold">{d.status}</span>
                      </div>
                    </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;
